import { TableCell, TableRow, IconButton, Link } from '@mui/material'
import CircleCheckbox from 'src/Component/CircleCheckbox'
import eyeIcon from 'src/assets/icons/eyeIcon.png'
import deleteIcon from 'src/assets/icons/deleteIcon.png'

type DataRowProps = {
  id: number
  name: string
  video: string
  equipmentNeeded: string
  time: number
  instruction: string
  onViewDetailsClick: (id: number) => void
  onDeleteClick: (id: number) => void
  onEditClick: (id: number) => void
  selected: boolean
  onSelect: (id: number) => void
}
const DataRow = ({
  id,
  name,
  video,
  equipmentNeeded,
  time,
  instruction,
  selected,
  onViewDetailsClick,
  onDeleteClick,
  onSelect,
  onEditClick,
}: DataRowProps) => {
  return (
    <TableRow hover tabIndex={-1}>
      <TableCell padding='checkbox'>
        <CircleCheckbox checked={selected} onChange={(checked) => onSelect(id)} />
      </TableCell>
      <TableCell onClick={() => onEditClick(id)}>
        {' '}
        <span
          style={{
            borderBottom: '1px solid white',
            cursor: 'pointer',
          }}
        >
          {name}
        </span>{' '}
      </TableCell>
      <TableCell>
        <Link href={video} target='_blank' color={'inherit'}>
          Video.mp4
        </Link>
      </TableCell>
      <TableCell>{equipmentNeeded}</TableCell>
      <TableCell>{time} mins</TableCell>
      <TableCell>{instruction}</TableCell>

      <TableCell align='center'>
        <IconButton onClick={() => onViewDetailsClick(id)}>
          {' '}
          <img src={eyeIcon} alt='eyeIcon' />{' '}
        </IconButton>
        <IconButton onClick={() => onDeleteClick(id)}>
          {' '}
          <img src={deleteIcon} alt='deleteIcon' />{' '}
        </IconButton>
      </TableCell>
    </TableRow>
  )
}

export default DataRow
